export default __webpack_public_path__ + "static/media/img_ceo-3.3fba99fa.png";